import Vue from "vue";
import Router from "vue-router";
import store from '../store/index.js'

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/home",
    },
    // 首页
    {
      path: "/home",
      name: "home",
      component: () => import("../view/home.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器(isShowPlayMusic为true就显示播放器)
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    // 歌曲详情
    {
      path: "/musicDetail",
      name: "musicDetail",
      component: () => import("../view/musicDetail.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
      },
    },
    // 购物车
    {
      path: "/shoppingCart",
      name: "shoppingCart",
      component: () => import("../view/shoppingCart.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    // 支付订单
    {
      path: "/payOrder",
      name: "payOrder",
      component: () => import("../view/payOrder.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    // 认证页面
    {
      path: "/authentication",
      name: "authentication",
      component: () => import("../view/authentication.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    // 常见条款
    {
      path: "/commonProblem",
      name: "commonProblem",
      component: () => import("../view/commonProblem.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: false,
      },
    },
    {
      path: "/customer",
      name: "customer",
      component: () => import("../view/customer.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: false,
      },
    },
    // 个人中心
    {
      path: "/personalCenter",
      name: "personalCenter",
      component: () => import("../view/personalCenter.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    // 加载
    {
      path: "/loading",
      name: "loading",
      component: () => import("../view/loading.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    // 歌单
    {
      path: "/Bigger",
      name: "Bigger",
      component: () => import("../view/Bigger.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    // 合作案例点击更多
    {
      path: "/case",
      name: "case",
      component: () => import("../view/case.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    //案例详情
    {
      path: "/caseDetail",
      name: "caseDetail",
      component: () => import("../view/caseDetail.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    //帮助中心
    {
      path: "/Help",
      name: "Help",
      component: () => import("../view/Help.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    //场景的首页
    {
      path: "/sceneHome",
      name: "sceneHome",
      component: () => import("../view/sceneHome.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    //订单预览
    {
      path: "/orderPreview",
      name: "orderPreview",
      component: () => import("../view/orderPreview.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
    //合格证
    {
      path: "/qualification",
      name: "qualification",
      component: () => import("../view/qualification.vue"),
      meta: {
        // 如果不显示底部就显示音乐播放器
        isShowPlayMusic: true,
        bothHidden: true,
      },
    },
  ],
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// 全局的前置守卫
router.beforeEach((to, from, next) => {
  if(to.name != 'sceneHome' && to.name != 'home' && to.name != 'Help'){
    console.log(to.name,'to.name');
   store.commit('setHeaderIndex', -1)
  }
  next()
})

export default router;
